import { Box, Button, Stack, Typography } from '@mui/material';
import { PageContainer } from '@/components/shared/page-container';
import { getSvg } from '@/utils/get-svg';

export const NotFound = () => (
  <PageContainer>
    <Stack py={10} textAlign="center" alignItems="center" spacing={2}>
      <Box
        component="img"
        src={getSvg('empty_state_catalog.svg')}
        sx={{ width: 160 }}
      />
      <Typography variant="h2">Curso não encontrado.</Typography>
      <Typography>
        Este curso pode ter sido removido ou atualizado. Que tal explorar outros
        cursos no catálogo?
      </Typography>
      <Button href="/" variant="contained">
        Ir para o catálogo
      </Button>
    </Stack>
  </PageContainer>
);
